import React from 'react'
import { Link } from 'react-router-dom'

export default function Pagenotfound() {
  const pageNotFoundStyle = {
    top: '50%',
    position: 'absolute',
    left: '35%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };
  return (
    <div style={pageNotFoundStyle}>
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <button className='btn btn-dark'><Link to="/"style={{textDecoration:"none",color:"white"}}>Home</Link></button>
    </div>
  )
}